import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { useLanguage } from "@/contexts/LanguageContext";
import { translations } from "@/i18n/translations";
import Navigation from "@/components/Navigation";
import Footer from "@/components/Footer";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

const FAQ = () => {
  const { language } = useLanguage();
  const t = translations[language].footer;

  return (
    <div className="min-h-screen bg-background">
      <Navigation />
      
      <main className="container mx-auto px-4 sm:px-6 lg:px-8 py-24 sm:py-32">
        <div className="max-w-3xl mx-auto">
          <Link 
            to="/" 
            className="inline-flex items-center gap-2 text-muted-foreground hover:text-primary transition-colors mb-8"
          >
            <ArrowLeft className="w-4 h-4" />
            {language === 'nl' ? 'Terug naar Home' : 'Back to Home'}
          </Link>

          <h1 className="text-3xl sm:text-4xl font-bold text-foreground mb-4">
            {t.faq}
          </h1>
          
          <p className="text-muted-foreground mb-8">
            {language === 'nl' 
              ? 'Hier vind je antwoorden op de meest gestelde vragen over PlayfieldVR.'
              : 'Here you will find answers to the most frequently asked questions about PlayfieldVR.'
            }
          </p>

          {/* forceMount houdt elk antwoord permanent in de DOM (ook ingeklapt),
              zodat crawlers de volledige tekst kunnen lezen. */}
          <Accordion type="single" collapsible className="w-full">
            {t.faqItems.map((item, index) => (
              <AccordionItem key={index} value={`faq-${index}`} className="border-border">
                <AccordionTrigger className="text-left text-base sm:text-lg text-foreground hover:text-primary hover:no-underline">
                  {item.question}
                </AccordionTrigger>
                <AccordionContent forceMount className="text-muted-foreground">
                  {item.answer}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>


          <div className="mt-12 p-6 bg-card/50 border border-border rounded-lg">
            <h2 className="text-xl font-semibold text-foreground mb-2">
              {language === 'nl' ? 'Nog vragen?' : 'Still have questions?'}
            </h2>
            <p className="text-muted-foreground mb-4">
              {language === 'nl' 
                ? 'Neem gerust contact met ons op. We helpen je graag verder!'
                : 'Feel free to contact us. We are happy to help!'
              }
            </p>
            <Link 
              to="/#contact-form" 
              className="inline-flex items-center gap-2 text-primary hover:text-primary/80 transition-colors font-medium"
            >
              {language === 'nl' ? 'Neem contact op' : 'Contact us'}
              <ArrowLeft className="w-4 h-4 rotate-180" />
            </Link>
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default FAQ;
